import { useEffect, useState } from 'react';
import { Category } from '../../../interfaces/Article.interface';
import SubcategoryBox from '../../atoms/subcategory-box/SubcategoryBox';

import './HomeCategoriesSelector.scss';


interface Props {
    dataCategoriesHome: {
        title: string,
        descrip: string,
        dataCategories: Category[];
    }
}

const HomeCategoriesSelector = ({ dataCategoriesHome }: Props) => {

    const [selectedCategory, setSelectedCategory] = useState<Category>({
        name: '',
        color: '',
        icon: '',
        subcategories: []
    });

    useEffect(() => {
        onChangeCategory(dataCategoriesHome.dataCategories[0].name);
    }, []);


    const onChangeCategory = (category: string) => {
        const selectedCategory = dataCategoriesHome.dataCategories.filter(cat => cat.name === category);
        setSelectedCategory(selectedCategory[0]);
    }

    return (
        <div className='m-home-categories-selector'>
            <div className='categories-selector__sidebar'>
                <div className='a-sidebar__title'>
                    <h2>{dataCategoriesHome.title}</h2>
                    <p>{dataCategoriesHome.descrip}</p>
                </div>
                <div className='a-sidebar__categories'>
                    {
                        dataCategoriesHome.dataCategories.map(category => (
                            <button
                                className={`${(category.name === selectedCategory.name) ? 'active-category' : ''} gtmExplorarporcategorias${category.name.replace(/ /g, '')}Home`}
                                key={category.name}
                                onClick={() => onChangeCategory(category.name)}
                            >
                                <div className={`category-icon gtmExplorarporcategorias${category.name.replace(/ /g, '')}Home`}>
                                    <i
                                        className={`${category.icon} gtmExplorarporcategorias${category.name.replace(/ /g, '')}Home`}
                                        style={{ color: ((category.name === selectedCategory.name) ? category.color : '') }}
                                    ></i>
                                </div>
                                <p className={`gtmExplorarporcategorias${category.name.replace(/ /g, '')}Home`}>{category.name}</p>
                            </button>
                        ))
                    }
                </div>
            </div>
            <div className='categories-selector__subcategories'>
                <h2 className='a-subcategories__text'>Resuelve tus dudas sobre {selectedCategory.name.toLowerCase()}</h2>
                <div className="a-subcategories__list">
                    {
                        selectedCategory.subcategories!.map(subcategory => (
                            <SubcategoryBox
                                key={subcategory.name}
                                subcategory={subcategory}
                                color={selectedCategory.color}
                            />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default HomeCategoriesSelector